import CreateEditAiAgentModal from './CreateEditAiAgentModal';

export default CreateEditAiAgentModal;